import './i18n';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Navbar from './components/Navbar/Navbar';
import BrandSuitability from './pages/brandSuitability/BrandSuitability';
import Segmentations from './pages/segmentations/Segmentations';
import BrandSafety from './pages/brandSafety/BrandSafety';
import AboutUs from './pages/aboutUs/AboutUs';
import Audit from './pages/audit/audit';
import Contact from './pages/contact/Contact';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './pages/privacyPolicy/PrivacyPolicy';
import { usePageTracking } from './hooks/usePageTracking';
import ExitIntentModal from './components/ExitModal/ExitIntentModal';
import DevPagePH3A from './pages/devOnly/DevPagePH3A'; // Will become deprecated as soon as PH3A test is done

function App() {
  usePageTracking();

  return (
    <div>
      <ScrollToTop />
      <Navbar />

      <ExitIntentModal />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/segmentacoes" element={<Segmentations />} />
        <Route path="/brandSafety" element={<BrandSafety />} />
        <Route path="/brandSuitability" element={<BrandSuitability />} />
        <Route path="/quemSomos" element={<AboutUs />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/gdpr" element={<PrivacyPolicy />} />
        <Route path="/oba" element={<PrivacyPolicy />} />
        <Route path="/dev" element={<DevPagePH3A />} />
      </Routes>
    </div>
  );
}

export default App;
